import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.user.title-non-final',
		defaultMessage: 'Your work from Opsgenie is shifting to Jira',
		description: 'Title for the first unlocked admin content for the optimal wizard',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.user.description-non-final',
		defaultMessage:
			'Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work.',
		description: 'Description for the first unlocked admin content for the optimal wizard',
	},
	listTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.user.list-title-non-final',
		defaultMessage: 'Let’s go set up a few things so you can get started',
		description:
			'Title for the list of configurations that need to be set up for the optimal wizard',
	},
	configureNotificationSettingsNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.user.configure-notification-settings-non-final',
		defaultMessage: 'Configure your notifications settings in Jira',
		description: 'Description for configuring chat integrations for the optimal wizard',
	},
	learnHowToWorkNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.user.learn-how-to-work-non-final',
		defaultMessage: 'Learn how operations works on Jira Service Management',
		description:
			'Description for learning how operations works on Jira Service Management for the optimal wizard',
	},
});
